import React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "./landing.scss";

import dexter_logo from "../../img/dexter-logo.svg";

import { Fade } from "@mui/material";
import _checkTokenExpiry from "../../utilities/_checkTokenExpiry";
import { NavLinkList } from "../NewNavbar/config";
import { filterByUserScope } from "../../utilities/helpers";

class LandingPage extends React.Component {
  MenuNavLink = (navLinkList) =>
    navLinkList.map((item, index) => (
      <Fade in={true} timeout={500 + index * 200} key={item.name}>
        <div
          onClick={() => this.props.history.push(item.to)}
          className="link-description"
        >
          <img src={item.icon} className="new-navlink-icon" alt={item.name} />
          <span className="link-description-name">{item.name}</span>
        </div>
      </Fade>
    ));

  render() {
    _checkTokenExpiry();
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    const name = JSON.parse(localStorage.getItem("name"));
    if (!localUserToken) return <Redirect to="/signin" />;
    let current_time = Date.now().valueOf() / 1000;
    if (this.props.expiration < current_time) this.props.signOut();
    return (
      <div className="landing-container">
        <img src={dexter_logo} alt="Dexter Logo" />
        <p className="username">Hello, {name}!</p>
        <div className="link-container">
          {/* {portalType === "kam" && this.MenuNavLink(NavKAMList)} */}
          {this.MenuNavLink(NavLinkList.filter(filterByUserScope))}
        </div>
        <NavLink to="/signout" className="signout-link">
          Sign Out
        </NavLink>
        {/* <h2>LandingPage</h2> */}
      </div>
    );
  }
}

export default withRouter(LandingPage);
